<template lang="pug">
  .faq.has-text-left.columns
    .column.is-8
      .faq-questions
        h2.title {{legal.name}}
        div.has-text-weight-normal(v-html="legal.html")
        router-link.button.is-primary.faq-button(to="/legal", style="margin-top: 3rem") GO BACK
    .column.is-4
      .faq-contact-us
        .box
          h2.title Can't find the answer you're looking for?
          router-link.button.is-primary.faq-button(to="/contact-us") CONTACT US
</template>

<script>
  import { find } from 'lodash'

  export default {
    props: ['type', 'question'],
    async mounted() {
      if (!this.$store.getters.getLegal) {
        await this.$store.dispatch('fetchLegal')
      }
    },
    computed: {
      legal() {
        return find(this.$store.getters.getLegal, v => v.category === this.type && v.name === this.question.split('_').join(' '))
      }
    }
  }
</script>


<style lang="scss">
  @import "../styles/variables";

  .faq {
    padding: 3rem;

    .faq-questions {

      .faq-type {
        background-color: rgb(250, 250, 250);
        cursor: pointer;
        position: relative;
        font-weight: normal;

        .faq-type-name {
          text-transform: uppercase;
          display: flex;
          padding: 0.5rem 1rem;

          .faq-type-title {
            flex: 1;
          }
        }

        &:hover .faq-options {
          display: block;
        }

        .faq-options {
          position: absolute;
          width: 100%;
          background-color: rgb(250, 250, 250);
          display: none;


          .faq-option {
            padding: 0.5rem 1rem;
            display: block;
            color: $secondary-colour;

            &:hover {
              background-color: $primary-colour;
              color: #FFF;
            }
          }
        }
      }
    }

    .faq-button {
      border-radius: 0;
      padding: 1.25rem 2rem;
    }
  }
</style>
